/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Ongoing/view.blocks to change it.
import ButtonSecondary from 'DesignSystem/ButtonSecondary/index'
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Ongoing({
  children,
  viewPath = "/App/Form/Progress/Ongoing",
  toggleProvideDataReviewData,
  progress = "8%",
  isReviewData
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
  return (<React.Fragment
>
<div
  data-testid="Ongoing.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={toggleProvideDataReviewData}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Ongoing.ProgressBar"
  data-view-path={viewPath}
 className={`views-block ${styles.ProgressBar}`}
>
<div
  data-testid="Ongoing.Horizontal:1"
  data-view-path={viewPath}
 style={{'--w-1-oYJcC': typeof progress === 'number' ? `${progress}px` : progress}}
 className={`views-block ${styles.Horizontal1}`}
/>
</div>
<ButtonSecondary
  viewPath={`${viewPath}/ButtonSecondary`}
 marginLeft={15}
 onClick={toggleProvideDataReviewData}
 text={isReviewData ? "Answer" : "Review"}
 width={70}
/>
</div>
{children}
</React.Fragment>)
}